import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Matrimony CEO - Privacy Policy
            </h1>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>

          {/* Introduction */}
          <div className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              "www.matrimonystudio.in" (Website) and "Matrimony CEO" (App) are online matrimonial services operated by riyatechpark.com. We respect your right to privacy, and this Privacy Policy explains how we collect, use, and safeguard your personal information. By using the Website/App, you agree to the collection and use of your information as described in this policy. If you do not agree with this Privacy Policy, please do not use our services.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-8">
            {/* Section 1 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                1. What Information Do We Collect?
              </h2>
              <p className="text-gray-700 mb-4">
                We may collect the following personal and technical information:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li><strong>Personal Information:</strong> Photo, email address, full name, height, educational details, password, residential address, PIN code, phone/fax number.</li>
                <li><strong>Payment Information:</strong> Credit/Debit card details, e-checks, and demand draft tracking (if applicable).</li>
                <li><strong>Technical Information:</strong> Device number, log files, geographic location, IP address, and browser type.</li>
                <li><strong>Third-Party Login Data:</strong> If you register using platforms like Facebook, Google, or LinkedIn, we may access and process that account data as permitted.</li>
              </ul>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                2. How We Use This Information
              </h2>
              <p className="text-gray-700 mb-4">
                Your information is used for:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Account verification, login, and service activation.</li>
                <li>Providing a personalized experience and recommendations.</li>
                <li>Ensuring security, fraud prevention, and legal compliance.</li>
                <li>Conducting marketing research, analytics, and service improvements.</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                3. Cookies Collection
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>We use cookies (small browser files) to store login and usage data.</li>
                <li>Third-party cookies may also be used, which are outside our control.</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                4. Special Rules for EU Residents
              </h2>
              <p className="text-gray-700 mb-4">
                If you reside in the European Union (EU):
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>We will request your explicit consent before collecting personal data.</li>
                <li>You have rights to access, update, delete, or revoke the processing of your data.</li>
                <li>Your data may be transferred outside the EU (e.g., to India), but with appropriate safeguards.</li>
                <li>For any data-related requests, email us at <a href="mailto:madhulotmall108@gmail.com" className="text-blue-600 hover:underline">madhulotmall108@gmail.com</a>.</li>
                <li>We may share your data with fraud prevention services in the UK as required.</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                5. Information Sharing
              </h2>
              <p className="text-gray-700 mb-4">
                We may share your information with:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Our affiliate companies and service providers.</li>
                <li>Fraud prevention authorities (especially in the UK).</li>
                <li>Law enforcement or legal bodies when required by law.</li>
                <li>During business transitions such as mergers, acquisitions, or asset sales.</li>
              </ul>
              <p className="text-gray-700 mt-4">
                <strong>Note:</strong> We are not responsible for the privacy practices of third-party websites or apps linked to ours.
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                6. Data Retention
              </h2>
              <p className="text-gray-700 mb-4">
                We retain your information:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>As long as you use our services.</li>
                <li>For legal compliance, dispute resolution, audits, and business purposes.</li>
              </ul>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                7. Security Measures
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>We implement both technical and organizational security measures to protect your data.</li>
                <li>While we take all reasonable steps to protect your data, no online platform can be 100% secure.</li>
              </ul>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                8. Changes to This Privacy Policy
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>We may update this Privacy Policy without prior notice.</li>
                <li>All updates will be posted on our website. Please review it periodically.</li>
              </ul>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                9. Privacy Contact Officer
              </h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="space-y-2 text-gray-700">
                  <p><strong>Name:</strong> Mr. Sangannamoni Maddileti</p>
                  <p><strong>Email:</strong> <a href="mailto:madhulotmall108@gmail.com" className="text-blue-600 hover:underline">madhulotmall108@gmail.com</a></p>
                  <div>
                    <p><strong>Address:</strong></p>
                    <div className="ml-4 mt-1">
                      <p>riyatechpark.com</p>
                      <p>H No: 16-115/C, Boinpet, Manthani,</p>
                      <p>Peddapally, Telangana, India - 505184</p>
                    </div>
                  </div>
                  <p><strong>Office Hours:</strong> Monday to Saturday, 10:00 AM to 7:00 PM</p>
                  <p className="text-sm text-gray-600">(Closed on Sundays and Indian public holidays)</p>
                </div>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-gray-700 text-center leading-relaxed">
              Matrimony CEO is a product developed by riyatechpark.com, with the goal of providing a trusted and enriching matrimonial experience for users.
            </p>
          </div>

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button 
              onClick={() => window.history.back()} 
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition duration-200"
            >
              ← Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 